<template>
  <span class="badge" :class="variant">
    {{ text }}
  </span>
</template>

<script>
export default {
  name: "Badge",
  props: {
    text: {
      type: String,
      required: true
    },
    variant: {
      type: String,
      default: ""
    }
  }
};
</script>

<style scoped>
.badge {
  display: inline-block;
  padding: 0.25rem 0.5rem;
  font-size: 0.75rem;
  font-weight: 600;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 0.25rem;
  margin-right: 0.25rem;
  margin-bottom: 0.25rem;

  &.grey {
    background-color: #f3f3f3;
    color: #645e5e;
  }

  &.success {
    background-color: green;
    color: white;
  }

  &.danger {
    background-color: red;
    color: white;
  }

  &.yellow {
    background-color: yellow;
    color: #333;
  }
}
</style>
